// @ts-nocheck
import { fetch } from "@insite/client-framework/ServerSideRendering";

export interface ValidatePasswordApiParameter {
    userName: string;
    password?: string;
    accessToken: string;
}

export type ServiceResult =
    | {
          successful: true;
      }
    | {
          successful: false;
          errorMessage: string;
          statusCode?: number;
      };

const sessionsUrl = "/api/v1/sessions";

export async function doValidatePassword(parameter: ValidatePasswordApiParameter): Promise<ServiceResult> {
    const { accessToken, ...otherProps } = parameter;

    const response = await fetch(sessionsUrl, {
        method: "POST",
        headers: getHeader(parameter.accessToken),
        body: JSON.stringify(otherProps),
    });

    if (response.status < 200 || response.status >= 300) {
        let errorMessage: string;
        let errorJson: any;
        if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            errorJson = (await response.json()) as { message: string };
            errorMessage = errorJson.message;
        } else {
            errorMessage = await response.text();
        }
        return {
            successful: false,
            errorMessage,
            statusCode: response.status,
        };
    }

    return {
        successful: true,
    };
}

function getHeader(accessToken: string | undefined) {
    const header = {
        Accept: "application/json, text/plain, */*",
        "Content-Type": "application/json",
    } as any;

    if (accessToken) {
        header["authorization"] = `Bearer ${accessToken}`;
    }

    return header;
}
